import React from "react";
import { NavLink } from "react-router-dom";
import UserMenu from "./UserMenu";
import FiltersBar from "./FiltersBar";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj } from '../../analytics/analyticsObject';
const TopNav = ({
  isAuthenticated,
  canProceed,
  showFiltersModal,
  setShowFiltersModal,
  showMobileSearch,
  setShowMobileSearch,
  isFilterModalVisible,
  searchProps,
  searchresultsCount,
  isMember, hasAccessUntil,hasAccess
}) => {

  const adobeCustomLog = (path, url) => {
    let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    let customLObj = getAdobeAnalyticsCustomLinkObj(path, "headers", url);
    pushDatatoAdobeLayer({
      customLinkData: { ...customEventObj, ...customLObj },
      pageData: false,
      adobePushTracking: false,
    });
  }
  return (
    <div>
      <div className="header-font z-40 fixed pin-t w-full bg-white shadow px-5 md:px-20" adoberegion='headers'>
        <div className="container mx-auto">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <NavLink to={isAuthenticated ? "/home" : "/"}>
                <img
                  className="hidden md:inline-block"
                  src="/images/pmi_logo_v5.png"
                  alt="PMI Logo"
                  style={{ width: "25rem" }}
                  onClick={() => adobeCustomLog('PMI-LOGO', '/home')}
                />
              </NavLink>

              <NavLink to={isAuthenticated ? "/home" : "/"}>
                <img
                  className="img-custom md:hidden"
                  src="/images/pmi-logo-only.png"
                  alt="PMI Logo"
                  style={{ maxWidth: "50px" }}
                  onClick={() => adobeCustomLog('S+', '/home')}
                />
              </NavLink>
            </div>
            {searchProps && (
              <div className="px-3" style={{ width: "40rem" }}>
                <FiltersBar
                  canProceed={canProceed}
                  showMobileSearch={showMobileSearch}
                  setShowMobileSearch={setShowMobileSearch}
                  showFiltersModal={showFiltersModal}
                  setShowFiltersModal={setShowFiltersModal}
                  isFilterModalVisible={isFilterModalVisible}
                  searchProps={searchProps}
                  searchresultsCount={searchresultsCount}
                  isMember={isMember}
                  hasAccessUntil={hasAccessUntil}
                  hasAccess={hasAccess}
                />
              </div>
            )}
            <div>
              <UserMenu isAuthenticated={isAuthenticated} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopNav;
